const isPojo = maybePojo => maybePojo && maybePojo.constructor && maybePojo.constructor === Object;

export default isPojo;
